'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const FatigueMeterType=require('../../../dist-es6/shared/domain/fatigueMeterType');
const Formatters=require('../../../dist-es6/client/formatters');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const IncidentViewModel=require('../../../dist-es6/client/viewModels/incidentViewModel');
const CalendarDay=require('pulsar-utils/dist-es6/time/calendarDay');
const CalendarRange=require('pulsar-utils/dist-es6/time/calendarRange');
const ErrorMessages=require('../../../dist-es6/client/errorMessages');
const TimeSeries=require('../../../dist-es6/client/utilities/timeSeries');

const _DutyTruncationPoint=timespan.fromHours(8).totalMilliseconds();
const _MaxDifferenceBetweenEndOfScheduleAndNow=timespan.fromMinutes(30).totalMilliseconds();let

PersonalScheduleDataService=function(_BaseService){_inherits(PersonalScheduleDataService,_BaseService);
function PersonalScheduleDataService(personService,
notificationService,
scheduleService,
statisticsService,
rasterizationService,
personalFatigueThresholdService,
personalIncidentsService,
userService,
fatigueMeterTypeContentProviderService,
timeFormattingService){_classCallCheck(this,PersonalScheduleDataService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));

_this._personService=personService;
_this._notificationService=notificationService;
_this._scheduleService=scheduleService;
_this._statisticsService=statisticsService;
_this._rasterizationService=rasterizationService;
_this._personalFatigueThresholdService=personalFatigueThresholdService;
_this._personalIncidentsService=personalIncidentsService;
_this._userService=userService;
_this._fatigueMeterTypeContentProviderService=fatigueMeterTypeContentProviderService;
_this._timeFormattingService=timeFormattingService;return _this;
}PersonalScheduleDataService.prototype.





tryGetPersonInfoAndWeeksInQueryInterval=function(){var ref=_asyncToGenerator(function*(){let{id:personId,employeeId:employeeId}=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};let queryInterval=arguments[1];let timezone=arguments[2];
_.ensureInstanceOf('string',personId,{nullable:!0});
_.ensureInstanceOf('string',employeeId,{nullable:!0});
_.ensureInstanceOf(TimeInterval,queryInterval);
_.ensureInstanceOf('string',timezone,{nullable:!0});

const personIdentifier=_.exists(employeeId)?`employeeId=${encodeURIComponent(employeeId)}`:personId;
const personInfoResponse=yield this._personService.getPersonInfoFor(personIdentifier,queryInterval.isPoint());

if(personInfoResponse.status!=='Ok'){
const message=personInfoResponse.status==='NotFound'?
`${this._fatigueMeterTypeContentProviderService.personTypeLabelSingular} not found in current organization.`:
ErrorMessages.OopsTryAgain;

this._notificationService.displayNotification(message,'error');
return{error:personInfoResponse.status};
}

const personInfo=personInfoResponse.body;


const weeksInQueryInterval=PersonalScheduleDataService.getWeeksForQueryInterval(queryInterval,timezone||personInfo.homeTimezone,personInfo.predictedWorkday);

return{personInfo:personInfo,weeksInQueryInterval:weeksInQueryInterval};
});function tryGetPersonInfoAndWeeksInQueryInterval(){let{id:personId,employeeId:employeeId}=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};let queryInterval=arguments[1];let timezone=arguments[2];return ref.apply(this,arguments)}return tryGetPersonInfoAndWeeksInQueryInterval}();PersonalScheduleDataService.prototype.

getScheduleDataFor=function(){var ref=_asyncToGenerator(function*(personInfo,weeks,timezone){var _this2=this;
_.ensureInstanceOf(Object,personInfo);
_.ensureInstanceOf('string',personInfo.id);
_.ensureInstanceOf('string',personInfo.homeTimezone);
_.ensureArrayOf(TimeInterval,weeks);

let{fatigueThreshold:fatigueThreshold,deviationThreshold:deviationThreshold,groupMemberships:groupMemberships}=yield this._personalFatigueThresholdService.getTresholdAndGroupInfoFor(personInfo.id);

let weekSectionModels=yield Promise.all(weeks.map(function(w){return _this2._loadDataForWeek(personInfo,timezone,w,fatigueThreshold,deviationThreshold,groupMemberships)}));
let now=_.get(weekSectionModels[0],'personalSchedule.now');
let timeOfLastScheduleUpdate=_.get(weekSectionModels[0],'personalStatistics.lastKnownStatus.time');
let timeOfLastHosStatus=_.get(weekSectionModels[0],'personalStatistics.timeOfLastHosStatus');
let invalidDataWarning=this._getInvalidDataWarning({personInfo:personInfo,now:now,timeOfLastScheduleUpdate:timeOfLastScheduleUpdate,timeOfLastHosStatus:timeOfLastHosStatus,timezone:timezone});
let predictedWorkday=_.get(_.findLast(weekSectionModels,function(m){return m.personalSchedule.predictedWorkday}),'personalSchedule.predictedWorkday');
let forecastDutyInterval=_.get(_.findLast(weekSectionModels,function(m){return m.personalSchedule.forecastDutyInterval}),'personalSchedule.forecastDutyInterval');
let displayTimeZone=this.getDisplayTimeZoneFor(_.get(weekSectionModels,'0.dailySchedules'),timezone);



const rawEstimateAsOfTime=_.get(weekSectionModels[0],'personalSchedule.estimatesAsOfTime');
const estimatesAsOfTime=_([timeOfLastScheduleUpdate,rawEstimateAsOfTime]).compact().max(function(d){return d.getTime()});

return{
weekSectionModels:weekSectionModels,
now:now,
timeOfLastScheduleUpdate:timeOfLastScheduleUpdate,
timeOfLastHosStatus:timeOfLastHosStatus,
invalidDataWarning:invalidDataWarning,
predictedWorkday:predictedWorkday,
forecastDutyInterval:forecastDutyInterval,
estimatesAsOfTime:estimatesAsOfTime,
fatigueThreshold:fatigueThreshold,
deviationThreshold:deviationThreshold,
groupMemberships:groupMemberships,
displayTimeZone:displayTimeZone};

});function getScheduleDataFor(personInfo,weeks,timezone){return ref.apply(this,arguments)}return getScheduleDataFor}();PersonalScheduleDataService.prototype.

_loadDataForWeek=function(){var ref=_asyncToGenerator(function*(personInfo,timezone,weekInterval,fatigueThreshold,deviationThreshold,groupMemberships){

let[personalSchedule,personalStatistics]=yield Promise.all([
this._scheduleService.getScheduleFor(personInfo,weekInterval,timezone),
this._statisticsService.getPersonalStatisticsFor(personInfo,weekInterval,timezone)]);



const endOfSchedule=_.get(personalSchedule,'bounds.end');
if(_.exists(endOfSchedule)){

if(personalSchedule.fatigue.length>0){
const endPoint=TimeSeries.getInterpolatedPointAtTime(personalSchedule.fatigue,endOfSchedule);
const endTime=endPoint.time.getTime();
personalSchedule.fatigue=_.takeWhile(personalSchedule.fatigue,function(p){return p.time.getTime()<endTime}).concat(endPoint);
}

const{predictedWorkday:predictedWorkday}=personalSchedule;
const pastFutureSplit=personalStatistics.currentStatusSource==='effectiveStatus'?_.get(personalStatistics,'lastKnownStatus.time'):endOfSchedule;

if(predictedWorkday&&pastFutureSplit&&predictedWorkday.end.getTime()>pastFutureSplit.getTime()){
personalSchedule.forecastDutyInterval=TimeInterval.from(pastFutureSplit).to(predictedWorkday.end);
}

if(personalSchedule.forecastDutyInterval&&_.get(personalSchedule,'forecastFatigue.length',0)>0){
const startPoint=TimeSeries.getInterpolatedPointAtTime(personalSchedule.forecastFatigue,personalSchedule.forecastDutyInterval.start);
const endPoint=TimeSeries.getInterpolatedPointAtTime(personalSchedule.forecastFatigue,personalSchedule.forecastDutyInterval.end);
const startTime=startPoint.time.getTime();
const endTime=endPoint.time.getTime();

const filteredForecastFatigue=[startPoint].
concat(_(personalSchedule.forecastFatigue).
skipWhile(function(p){return p.time.getTime()<=startTime}).
takeWhile(function(p){return p.time.getTime()<endTime}).
value()).
concat([endPoint]);

if(personalStatistics.currentStatusSource==='effectiveStatus'){
const lastForecastFatigueTime=_.last(filteredForecastFatigue).time.getTime();
const beforeForecast=_.takeWhile(personalSchedule.fatigue,function(p){return p.time.getTime()<=pastFutureSplit.getTime()});
const afterForecast=_.dropWhile(personalSchedule.fatigue,function(p){return p.time.getTime()<=lastForecastFatigueTime});
personalSchedule.fatigue=beforeForecast.concat(filteredForecastFatigue).concat(afterForecast);
}else{
personalSchedule.fatigue=personalSchedule.fatigue.concat(filteredForecastFatigue);
}
}



const clipInterval=TimeInterval.from(pulsarDate.MinDate()).to(endOfSchedule);
const clippedSleep=TimeInterval.clip(personalSchedule.sleep).to(clipInterval);
for(const[original,clipped]of _.zip(personalSchedule.sleep,clippedSleep)){
if(!clipped){
break;
}
clipped.startTimezone=original.startTimezone;
clipped.endTimezone=original.end.getTime()===clipped.end.getTime()?original.endTimezone:original.startTimezone;
}
personalSchedule.sleep=clippedSleep;
}else{
personalSchedule.fatigue=[];
personalSchedule.sleep=[];
}


let dailySchedules=this._rasterizationService.rasterize(personalSchedule,weekInterval,'days',timezone);

this._attachThresholdStatusesToDailyFatigueSummaries(personalStatistics.dailyFatigueSummaries,fatigueThreshold);
this.attachThresholdStatusesDevationAndTimezoneToIncidents(personalSchedule.incidents,fatigueThreshold,deviationThreshold,timezone);
for(const schedule of dailySchedules){
if(!schedule.incidents||schedule.incidents.length===0){
continue;
}

this.attachThresholdStatusesDevationAndTimezoneToIncidents(schedule.incidents,fatigueThreshold,deviationThreshold,timezone,groupMemberships);
}
this.attachEffectiveThresholdsToDailySchedules(personalSchedule,dailySchedules,fatigueThreshold,deviationThreshold,timezone);

return{personalStatistics:personalStatistics,personalSchedule:personalSchedule,dailySchedules:dailySchedules,fatigueThreshold:fatigueThreshold};
});function _loadDataForWeek(personInfo,timezone,weekInterval,fatigueThreshold,deviationThreshold,groupMemberships){return ref.apply(this,arguments)}return _loadDataForWeek}();PersonalScheduleDataService.prototype.

attachEffectiveThresholdsToDailySchedules=function attachEffectiveThresholdsToDailySchedules(personalSchedule,dailySchedules,fatigueThreshold,deviationThreshold){
personalSchedule.effectiveThresholds=personalSchedule.dailyEffectiveStatuses.map(function(effectiveStatus){
return ThresholdStatus.getEffectiveThresholds({
fatigueThreshold:fatigueThreshold,
deviationThresholdDay:deviationThreshold,
fatigueHistory:_.get(effectiveStatus,'statistics.recentHistory.fatigue',null)}).
get(NotificationType.AllThresholdsExceeded);
});

for(let dayIndex in personalSchedule.effectiveThresholds){
dailySchedules[dayIndex].effectiveThreshold=personalSchedule.effectiveThresholds[dayIndex];
}
};PersonalScheduleDataService.prototype.

_attachThresholdStatusesToDailyFatigueSummaries=function _attachThresholdStatusesToDailyFatigueSummaries(dailyFatigueSummaries,fatigueThreshold){
for(let dayIndex in dailyFatigueSummaries){
let maxFatigueOnDuty=_.get(dailyFatigueSummaries[dayIndex],`maxFatigueOnDuty`);
let averageFatigueOnDuty=_.get(dailyFatigueSummaries[dayIndex],`averageFatigueOnDuty`);

dailyFatigueSummaries[dayIndex].maxFatigueOnDuty={
value:maxFatigueOnDuty,
thresholdStatus:this.getThresholdStatus(maxFatigueOnDuty,fatigueThreshold)};

dailyFatigueSummaries[dayIndex].averageFatigueOnDuty={
value:averageFatigueOnDuty,
thresholdStatus:this.getThresholdStatus(averageFatigueOnDuty,fatigueThreshold)};

}
};PersonalScheduleDataService.prototype.

attachThresholdStatusesDevationAndTimezoneToIncidents=function attachThresholdStatusesDevationAndTimezoneToIncidents(incidents,fatigueThreshold,deviationThreshold,timezone,groupMemberships){


for(const incident of incidents){
const recentHistoryFatigue=_.get(incident.statistics,'recentHistory.fatigue');
_.assign(incident,{
fatigueThresholdStatus:ThresholdStatus.fromScoreAndThreshold(incident.fatigue,fatigueThreshold),
deviationThresholdStatus:ThresholdStatus.fromFatigueDeviation(incident.fatigue,recentHistoryFatigue,deviationThreshold),
deviation:ThresholdStatus.getDeviationFrom(incident.fatigue,recentHistoryFatigue,deviationThreshold),
currentlyScopedGroupMemberships:groupMemberships,
incident:incident});

}
};PersonalScheduleDataService.

getWeeksForQueryInterval=function getWeeksForQueryInterval(queryInterval,timezone,predictedWorkday){
const startDay=CalendarDay.calendarDayFor({time:queryInterval.start,timezone:timezone});
const endDay=CalendarDay.calendarDayFor({time:queryInterval.isPoint()?queryInterval.end:new Date(queryInterval.end.getTime()-1),timezone:timezone});
const range=new CalendarRange(startDay,endDay);
const remainder=range.totalDays%7;
const roundedStartDay=remainder==0?startDay:startDay.plusDays(-(7-remainder));

const weeks=[];
const totalDays=new CalendarRange(roundedStartDay,endDay).totalDays;

for(let dayOffset=0;dayOffset<totalDays;dayOffset+=7){
weeks.push(new CalendarRange(roundedStartDay.plusDays(dayOffset),roundedStartDay.plusDays(dayOffset+6)).asExpandedTimeInterval(timezone));
}

if(queryInterval.isPoint()&&predictedWorkday&&weeks[0].contains(predictedWorkday.start)&&!weeks[0].contains(predictedWorkday.end)){

const weekContainingPredictionEnd=PersonalScheduleDataService.getWeeksForQueryInterval(TimeInterval.fromPoint(predictedWorkday.end),timezone)[0];
if(weekContainingPredictionEnd.contains(queryInterval.start)){
weeks[0]=weekContainingPredictionEnd;
}
}

return weeks;
};PersonalScheduleDataService.prototype.

getThresholdStatus=function getThresholdStatus(fatigueValue,fatigueThreshold){
return _.allExist(fatigueValue,fatigueThreshold)?
ThresholdStatus.fromScoreAndThreshold(fatigueValue,fatigueThreshold):
ThresholdStatus.NotApplicable;
};PersonalScheduleDataService.prototype.

getDisplayTimeZoneFor=function getDisplayTimeZoneFor(dailySchedules,timezone){
_.ensureInstanceOf(Array,dailySchedules);
_.ensureInstanceOf('string',timezone);

let endOfSundayTime=_.get(dailySchedules,'0.interval.end');
if(!_.allExist(timezone,endOfSundayTime)){
return null;
}


return Formatters.formatInLocale(endOfSundayTime,'',timezone,{displayTimeZone:!0});
};PersonalScheduleDataService.prototype.

getAllIncidentsFor=function(){var ref=_asyncToGenerator(function*(personId){
_.ensureInstanceOf('string',personId,{nullable:!0});

return yield this._personalIncidentsService.getAllIncidentsFor(personId);
});function getAllIncidentsFor(personId){return ref.apply(this,arguments)}return getAllIncidentsFor}();PersonalScheduleDataService.prototype.

_getInvalidDataWarning=function _getInvalidDataWarning(_ref){let{personInfo:personInfo,now:now,timeOfLastScheduleUpdate:timeOfLastScheduleUpdate,timeOfLastHosStatus:timeOfLastHosStatus,timezone:timezone}=_ref;
if(personInfo.activationStatus.value!=='activated'){
return`Deactivated ${this._timeFormattingService.timeAndFullDateInTimezone(personInfo.activationStatus.timeChanged,timezone)}.`;
}

if(_.exists(timeOfLastScheduleUpdate)&&_.exists(timeOfLastHosStatus)){
if(timeOfLastScheduleUpdate.getTime()-timeOfLastHosStatus.getTime()===_DutyTruncationPoint){

return`Check logs — Stuck on duty since ${this._timeFormattingService.timeAndFullDateInTimezone(timeOfLastHosStatus,timezone)}.`;
}
if(now.getTime()-timeOfLastScheduleUpdate.getTime()>_MaxDifferenceBetweenEndOfScheduleAndNow){
return`Last updated ${this._timeFormattingService.timeAndFullDateInTimezone(timeOfLastScheduleUpdate,timezone)}.`;
}
}

return void 0;
};_createClass(PersonalScheduleDataService,[{key:'_fatigueMeterType',get:function(){return _.get(this._userService,'currentUser.fatigueMeterType')}}]);return PersonalScheduleDataService}(BaseService);


module.exports=PersonalScheduleDataService;
//# sourceMappingURL=personalScheduleDataService.js.map
